import { render, staticRenderFns } from "./pendingSessionList.vue?vue&type=template&id=65a1a6b6&"
import script from "./pendingSessionList.vue?vue&type=script&lang=js&"
export * from "./pendingSessionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports